import React from "react";

const LangContext = React.createContext(null);
export default LangContext;
